import messages from './home.json' with { type: 'json' };

export const homeEn: Readonly<typeof messages> = messages;
